import { Box, Typography, Button, Divider, Grid, useMediaQuery, Dialog, DialogContent, DialogActions, TextField, Stack, FormControl, InputLabel, Select, MenuItem, CardActions, Card, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../network/endpoints";
import instId from "../network/instituteId";
import axios from "axios";
import Network from "../network/Network";
import parse from "html-react-parser";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FaQqSection from "../homepage/FaqSection";
import IframFormSection from "../homepage/IframeSection";
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";

const FreeResources = () => {

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const isMobile = useMediaQuery("(min-width:600px)");
    const [Endpoints, setEndpoints] = useState('');
    const [coursesList, setCoursesList] = useState([]);
    const [activeCoursesList, setActiveCoursesList] = useState([]);
    const [selectedSceduleList, setSelectedSceduleList] = useState([]);
    const [formModalOpen, setFormModalOpen] = useState(false);
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [selectCourse, setSelectCourse] = useState("");
    const [selectedItem, setSelectedItem] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
        getInstituteDetail();
        getAllCourses();
    }, []);

    useEffect(() => {
        if (coursesList?.length > 0) {
            getMergedSchedules()
        }
    }, [coursesList])

    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {
                setEndpoints(response?.data?.instituteTechSetting?.mediaUrl)
                // Endpoints = response?.data?.instituteTechSetting?.mediaUrl
            };
        } catch (error) {
            console.log(error);
        }
    };

    const getAllCourses = async () => {
        const response = await Network.fetchCourses(instId);
        const course = response?.courses || [];
        const ActivefilteredCourses = course.filter(course =>
            course?.active === true
        );
        setActiveCoursesList(ActivefilteredCourses);

        const filteredCourses = course.filter(course =>
            course?.active === true &&
            course?.tags?.some(tagObj => tagObj?.tag?.toLowerCase() === "free")
        );

        setCoursesList(filteredCourses);
    };

    const getMergedSchedules = async () => {
        try {
            let allSchedules = [];

            await Promise.all(
                coursesList.map(async (course) => {
                    const response = await Network.fetchCheduleApi(course.id, 0);
                    if (response?.contentList) {
                        const updatedList = response.contentList.map((item) => ({
                            ...item,
                            parentCourseId: course.id, // ✅ Add course ID here
                        }));
                        allSchedules = [...allSchedules, ...updatedList];
                    }
                })
            );
            setSelectedSceduleList(allSchedules);
        } catch (error) {
            console.error("Error fetching course schedules:", error);
        }
    };

    const handleCardClick = (item) => {
        setSelectedItem(item);
        setFormModalOpen(true);
    };

    const handleClose = () => {
        setName('');
        setNumber('');
        setSelectCourse('');
        setFormModalOpen(false);
    }
    // console.log('selectedItem', selectedItem);


    const handleSubmit = async () => {
        try {
            const body = {
                instId: instId,
                firstName: name,
                lastName: name,
                contact: number,
                campaignId: null,
                contentId: selectedItem?.parentCourseId,
                enquiryType: "course"
            }
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.post(
                BASE_URL + "leadManagement/create-lead-form", body,
                requestOptions
            );

            if (response?.data?.errorCode !== 0) {
                enqueueSnackbar(`${response?.data?.errorDescription}`, { variant: 'error', autoHideDuration: 3000 })
            } else if (response?.data?.errorCode === 0) {
                enqueueSnackbar(`Thank You For Submitting`, { variant: "success", autoHideDuration: 3000 }
                );
                if (selectedItem?.entityType === "video" && selectedItem?.video?.video) {
                    window.open(Endpoints + selectedItem?.video?.video, "_blank");
                } else if (selectedItem?.entityType === "note" && selectedItem?.note?.note) {
                    window.open(Endpoints + selectedItem?.note?.note, "_blank");
                } else if (selectedItem?.entityType === "blog" && selectedItem?.blog?.blog) {
                    navigate('/blog', { state: { blogData: selectedItem } })
                } else {
                    console.warn("No valid URL found for this item.");
                }
                setName('');
                setNumber('');
                setSelectCourse('');
                handleClose();
            }

        } catch (error) {
            console.log(error);
        }
    }

    const handleChangeCourse = (event) => {
        setSelectCourse(event.target.value)
    };

    return (
        <React.Fragment>
            <div className="" style={{ padding: '8rem 0 0 0' }}>
                <div className="col-xs-12 col-md-12 col-lg-12" style={{ background: "#fff", paddingLeft: "0px", paddingRight: "0px" }}>
                    <div style={{ paddingLeft: isMobile ? '0rem' : '0rem', paddingRight: isMobile ? '0rem' : '0rem', paddingTop: isMobile ? '0rem' : '0rem', paddingBottom: isMobile ? '4rem' : '0rem' }}>
                        <Grid container sx={{ paddingBottom: isMobile ? "" : "20px", pt: isMobile ? 4 : 4 }}>
                            {
                                selectedSceduleList?.length > 0 && selectedSceduleList?.map((item, i) => {
                                    if (item?.paid === false) {
                                        return <Grid item xs={12} sm={2} md={2} lg={2} sx={{ padding: "10px", textAlign: "center", pl: 2, }}>
                                            <Box sx={{ textAlign: "left", borderRadius: "10px", position: "relative", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", cursor: "pointer" }} onClick={() => handleCardClick(item)}>
                                                {
                                                    item?.thumb && (
                                                        <img src={Endpoints + item?.thumb} style={{ width: "100%", borderRadius: "8px" }} />
                                                    )
                                                }

                                                <Box sx={{ pb: 1 }}>
                                                    <Typography variant='h5' fontWeight={"bold"} sx={{ mt: 2, mb: 2, ml: 2, mr: 2, color: "black", pt: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                        {item?.title} &nbsp; {item?.entityType === "video" || item?.entityType === "blog" ? <PlayCircleIcon fontSize={'large'} /> : <PictureAsPdfIcon fontSize={'large'} />}

                                                    </Typography>
                                                    <Typography variant='p' sx={{ fontSize: "12px", ml: 2, mb: 2, mr: 2, display: "flex", justifyContent: "space-between" }}>
                                                        {/* {item?.description?.description ? parse(item?.description?.description) : ""} */}
                                                        {item.createdAt ? new Date(item.createdAt).toLocaleString('en-US', {
                                                            month: 'numeric',
                                                            day: 'numeric',
                                                            year: 'numeric',
                                                            hour: 'numeric',
                                                            minute: 'numeric',
                                                            hour12: true
                                                        }) : ""}
                                                        <Typography sx={{ color: "#09c23d", fontSize: "14px" }}>FREE</Typography>

                                                    </Typography>
                                                </Box>
                                                {/* <Box sx={{ position: "absolute", bottom: "0", left: 0, right: 0, padding: "0px 10px 0 10px" }}>
                                                <Button
                                                    sx={{ background: item.id === selectedPlan?.id ? "#001C4A" : "#1354C1", color: "#fff", margin: "10px 0px 10px 0px", width: "100%", fontWeight: "bold", padding: "5px", fontSize: "12px" }}
                                                    
                                                    className='button-hover'
                                                >
                                                    {item.id === selectedPlan?.id ? "Selected" : "Select Plan"}
                                                </Button>
                                            </Box> */}
                                            </Box>
                                        </Grid>
                                    }
                                })
                            }
                            {
                                selectedSceduleList?.length === 0 && (
                                    <Box sx={{ textAlign: "center", width: "100%", mb: 4, mt: 4 }}>
                                        <Typography fontWeight={'bold'} variant="h4" sx={{ textAlign: "center" }}>Not Available !!</Typography>
                                    </Box>
                                )
                            }
                        </Grid>
                    </div>
                </div>

            </div>
            {/* <IframFormSection endpointsUrl={Endpoints} /> */}
            <Dialog open={formModalOpen} onClose={() => setFormModalOpen(false)}>
                <DialogContent sx={{ flex: 1, padding: 0 }}>  {/* Remove padding and allow full height */}
                    <Grid container sx={{ height: "100%" }}>
                        <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ height: "100%", padding: "20px" }}>

                            <Card sx={{ maxWidth: 400, borderRadius: '15px', padding: 3 }}>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        // justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '1rem'
                                    }}
                                >
                                    <IconButton
                                        aria-label="close"
                                        onClick={handleClose}
                                        sx={{
                                            // p: 2,
                                            position: 'absolute',
                                            right: 20,
                                            top: 20,
                                            color: (theme) => theme.palette.grey[500],
                                        }}
                                    >
                                        <CloseIcon sx={{ color: "black" }} />
                                    </IconButton>
                                    <Typography variant="h5" textAlign={'center'} fontSize={'18px'} sx={{ fontWeight: "bold" }}>
                                        Claim Your Free Resources – Enter Your Details to Proceed! 😊
                                    </Typography>
                                    <Typography textAlign={'center'} fontSize={'14px'}>
                                        Enter your details to proceed and access your personalized learning content
                                    </Typography>
                                    <Box sx={{ mb: 1 }}>
                                        <Typography sx={{ color: "#000", fontSize: "15px", mb: "4px" }}>
                                            Your Name
                                        </Typography>
                                        <TextField
                                            id="your-name"
                                            InputProps={{
                                                style: {
                                                    background: '#fff',
                                                    borderRadius: '20px',
                                                    padding: "0px"
                                                }
                                            }}
                                            fullWidth
                                            placeholder="e.g. Example"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            sx={{ mt: 0 }}
                                        />
                                    </Box>

                                    <Box sx={{ mb: 1 }}>
                                        <Typography sx={{ color: "#000", fontSize: "15px", mb: "4px" }}>
                                            Mobile Number
                                        </Typography>
                                        <TextField
                                            id="your-name"
                                            InputProps={{
                                                style: {
                                                    background: '#fff',
                                                    borderRadius: '20px',
                                                    padding: "0px"
                                                }
                                            }}
                                            fullWidth
                                            type='number'
                                            placeholder='e.g. 1234567890'
                                            value={number}
                                            onChange={(e) => {
                                                const input = e.target.value;

                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(input)) {
                                                    setNumber(input);
                                                }
                                            }}
                                            error={number.length > 0 && number.length !== 10}
                                            helperText={number.length > 0 && number.length !== 10 ? "Phone number must be 10 digits" : ""}
                                            sx={{ mt: 0 }}
                                        />

                                    </Box>
                                    {/* <Box sx={{ mb: 1 }}>
                                        <Typography sx={{ color: "#000", fontSize: "15px", mb: "4px" }}>
                                            Interested Course
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            fullWidth
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            class="input-field"
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            sx={{
                                                background: '#fff', borderRadius: '20px'
                                            }}
                                            // label="Interested Course"
                                            // placeholder="select your course"
                                            value={selectCourse}
                                            onChange={handleChangeCourse}

                                        >
                                            <MenuItem value="" disabled>
                                                Select a course
                                            </MenuItem>
                                            {
                                                activeCoursesList && activeCoursesList.map((data, index) => {
                                                    return (
                                                        <MenuItem key={index} value={data}>{data?.title}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Box> */}
                                </Box>
                                <CardActions
                                    sx={{
                                        p: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mt: 2
                                    }}
                                >
                                    <Button
                                        disabled={!name || !number ? true : false}
                                        sx={{
                                            width: "100%",
                                            background: '#113CAF',
                                            textTransform: 'none',
                                            color: 'white',
                                            px: 3,
                                            borderRadius: '10px',
                                            fontWeight: '400',
                                            fontSize: '16px',
                                            border: '1px solid #767676',
                                            ':hover': {
                                                background: '#00278f'
                                            }
                                        }}
                                        onClick={handleSubmit}
                                    >
                                        Proceed
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                {/* <DialogActions>
                                <Button onClick={() => setFormModalOpen(false)}>Close</Button>
                            </DialogActions> */}
            </Dialog>
        </React.Fragment>
    );
};

export default FreeResources;
